import { combineReducers, Reducer } from 'redux';
import languageReducer from './language';
import matchMediaReducer from './matchMedia';
import loginUserReducer from './loginUser';
import { RootState } from '../types';

// const rootReducer: Reducer<RootState> = combineReducers<RootState>({
//   languageState: languageReducer,
// });

const rootReducer = combineReducers({
	languageState: languageReducer,
	loginUserState: loginUserReducer,
	matchMediaState: matchMediaReducer,
});

export default rootReducer;
